import { render, staticRenderFns } from "./TextareaView.vue?vue&type=template&id=0cd14250&"
import script from "./TextareaView.vue?vue&type=script&lang=js&"
export * from "./TextareaView.vue?vue&type=script&lang=js&"
import style0 from "./TextareaView.vue?vue&type=style&index=0&id=0cd14250&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports